// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"orsgG3","iconContainer":"_15ZjDj","icon":"_2yfKp6","preTitle":"_3mkiHJ"};